import { render, staticRenderFns } from "./NothingToDo.vue?vue&type=template&id=6d754aca"
import script from "./NothingToDo.vue?vue&type=script&lang=js"
export * from "./NothingToDo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports